var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircularShadowContractCheck = function SvgCircularShadowContractCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 359,
    height: 353,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "circular-shadow-contract-check_svg__b",
    width: 359,
    height: 353,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#circular-shadow-contract-check_svg__a)",
    d: "M0 0h359v353H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#circular-shadow-contract-check_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "circular-shadow-contract-check_svg__d",
    width: 359,
    height: 353,
    x: -2,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#circular-shadow-contract-check_svg__c)",
    d: "M-2 1h359v353H-2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.209,
    mask: "url(#circular-shadow-contract-check_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 172.5,
    cy: 175.5,
    r: 173.895,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 175,
    r: 158.395,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 175.5,
    r: 142.895,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.5,
    cy: 175.5,
    r: 126.895,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 176,
    r: 111.395,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 175,
    r: 95.395,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 175,
    r: 78.395,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.5,
    cy: 175.5,
    r: 62.895,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 176,
    r: 47.395,
    fill: "url(#circular-shadow-contract-check_svg__e)",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 175,
    r: 32.395,
    fill: "#2B2B2B",
    stroke: "#424242"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 175,
    r: 26.395,
    fill: "#424242",
    stroke: "#5F5F5F"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.113,
    d: "M172.646 185.271h4.958M168.396 170.396h9.208M169.812 174.646h6.375M183.271 185.271v-17.708a2.834 2.834 0 0 0-2.833-2.834h-14.875a2.834 2.834 0 0 0-2.834 2.834v7.791M162.729 183.146l2.125 2.125c1.063-3.188 4.25-4.959 4.25-4.959"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "circular-shadow-contract-check_svg__a",
    x1: 179.5,
    x2: 179.5,
    y1: 22.365,
    y2: 288.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circular-shadow-contract-check_svg__e",
    x1: 173,
    x2: 173,
    y1: 128,
    y2: 224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "circular-shadow-contract-check_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 176.5 -179.5 0 177.5 177.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
};
export default SvgCircularShadowContractCheck;